import axios from "axios";
import { HStack, View } from "native-base";
import React, { useEffect, useState } from "react";
import { BRANDING } from "../../../assets/consts";
import {
  faExclamationTriangle,
  faSearch,
} from "../../../assets/consts/faCharCodes";
import { ArButton } from "../../argon-ui";
import Theme from "../../argon-ui/Theme";
import { filterDomainName } from "../../hooks/filterDomainName";
import { IS_MOBILE, translate } from "../../locales/translate";
import InputBase from "../../nativeBase-ui/InputBase";
import Select from "../../nativeBase-ui/Select";
import { getServerInfo } from "../../util";
import ServerInfo from "../../viewModels/ServerInfo";
import FontAwesomeIcon from "../FontAwesomeIcon";
import QRScanner from "../QRScanner";
import ScannerCamera from "../ScannerCamera";
import Text from "../TextFont";

const PORT = "3030";
const SCHEME = ["http://", "https://"];
type Props = {
  onCancel?: () => void;
  onConfirmServer: (serverUrl: ServerInfo, serverAddress: string) => void;
};

const ServerIP = (props: Props) => {
  const { onCancel, onConfirmServer } = props;
  const [showScanner, setShowScanner] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const [scheme, setScheme] = useState<string>(
    BRANDING.NAME_EN === "TapLife" ? SCHEME[0] : SCHEME[1]
  );
  const [domainName, setDomainName] = useState<string>("");
  const [port, setPort] = useState(BRANDING.NAME_EN === "TapLife" ? PORT : "");

  const [loading, setLoading] = useState<boolean>(false);

  const onSearchHandler = async (serverUrl: string) => {
    setLoading(true);

    var httpClient = axios.create();
    httpClient.defaults.timeout = 5000;
    const _getServerInfo = await getServerInfo(httpClient, serverUrl);
    if (_getServerInfo) {
      const {
        serverId,
        publicAddress,
        localAddress,
        accessToken,
        userFullName,
        userId,
        ports,
      } = _getServerInfo;
      const serverInfoModel = new ServerInfo(
        serverId,
        publicAddress,
        localAddress,
        accessToken,
        userFullName,
        userId,
        ports
      );

      onConfirmServer(serverInfoModel, serverUrl);
    } else {
      setError(translate("serverList.errors.ServerError"));
      setTimeout(() => {
        setError("");
      }, 3000);
    }
    setLoading(false);
  };
  const handleBarCodeScanned = ({ type, data }: any) => {
    // console.log("data on barCode scanned", data);
    try {
      setShowScanner(false);
      if (data) {
        if (data.startsWith("http") || data.startsWith("https")) {
          // === remove /app from end address ===
          if (data.endsWith("/")) {
            data = data.slice(0, -1);
          }
          if (data.endsWith("/app")) {
            // data = data.substring(0, data.length - 4);
            data = data.replace("/app", " ");
          }
          onSearchHandler(data);
        }
      }
    } catch (err) {
      console.log("has error in get serverIp from Scan QRcode", err);
    }
  };
  const onCancelScanningHandler = () => {
    setShowScanner(false);
  };
  return (
    <View style={{ flex: 1, height: "100%", justifyContent: "space-between" }}>
      {/* === camera scanner === */}
      {showScanner ? (
        <ScannerCamera
          style={{ width: 280, height: 280 }}
          onBarCodeScanned={handleBarCodeScanned}
          onCancelScanning={() => onCancelScanningHandler()}
        />
      ) : (
        // === search inputs ===
        <>
          <View style={{ flex: 1 }}>
            <HStack
              space="1"
              w="100%"
              alignItems="center"
              justifyContent="space-between"
            >
              {/* === Port === */}
              {BRANDING.NAME_EN === "TapLife" && (
                <>
                  <InputBase
                    containerStyle={{ width: 55 }}
                    inputStyle={{ textAlign: "left" }}
                    value={port}
                    placeholder={PORT}
                    onChangeText={(txt: string) => setPort(txt)}
                  />
                  <Text style={{ fontSize: 18 }}>:</Text>
                </>
              )}
              {/* === Domain Name === */}
              <InputBase
                containerStyle={{ flex: 2.5 }}
                inputStyle={{ textAlign: "left", fontSize: 12 }}
                placeholder={filterDomainName(BRANDING.CLOUD_SERVER)}
                onChangeText={(txt: string) => {
                  txt = txt.replace(/\s+/g, "");
                  setDomainName(txt);
                }}
                value={domainName}
                // isInvalid={formValidityData.codeLetterError}
              />
              {/* === Scheme (http:// | https://) === */}
              <Select
                data={SCHEME.map((s) => {
                  return { value: s, label: s };
                })}
                value={scheme}
                onChangeText={(value: string) => {
                  setScheme(value);
                }}
                style={{
                  height: 50,
                  width: 40,
                  textAlign: "left",
                  direction: "ltr",
                  fontSize: 10,
                }}
                containerStyle={{ flex: 1.5, width: 40, maxWidth: 100 }}
                //   placeholder={SCHEME[0]}
              />
            </HStack>
            {error && (
              <View
                style={{
                  padding: 18,
                  backgroundColor: Theme.COLORS.ERROR + 20,
                  borderRadius: 10,
                  flexDirection: "row",
                  alignItems: "center",
                  marginBottom: 10,
                }}
              >
                <FontAwesomeIcon
                  icon={faExclamationTriangle}
                  color={Theme.COLORS.ERROR}
                  size={15}
                />
                <Text
                  style={{
                    color: Theme.COLORS.ERROR,
                    fontSize: 14,
                    marginHorizontal: 8,
                  }}
                >
                  {translate("app.serverError")}
                </Text>
              </View>
            )}
          </View>
          {IS_MOBILE && (
            <>
              <QRScanner
                onScanning={(isScanning: boolean) => {
                  setShowScanner(isScanning);
                }}
              />
            </>
          )}
          {/* === Submit Handler === */}
          <HStack space={2} mt="2.5">
            {/* === Submit Handler === */}
            <ArButton
              style={[
                { flex: 1, marginBottom: 0 },
                domainName.length < 4 && {
                  backgroundColor: Theme.COLORS.MUTED,
                },
              ]}
              isLoading={loading}
              color="primary"
              disabled={domainName.length < 4}
              icon={faSearch}
              onPress={() => {
                const generateUrl: string = scheme + domainName + ":" + port;
                onSearchHandler(generateUrl);
              }}
            >
              {translate("app.search")}
            </ArButton>
            <ArButton
              style={{ flex: 1, marginBottom: 0 }}
              color="muted"
              variant="outline"
              onPress={() => {
                typeof onCancel === "function" && onCancel();
              }}
            >
              {translate("app.cancel")}
            </ArButton>
          </HStack>
        </>
      )}
    </View>
  );
};

export default ServerIP;
